export const GITHUB_USERNAME = 'blackwolf2902';
export const GITHUB_API_BASE = 'https://api.github.com';

export const EVENT_ICONS = {
  PushEvent: 'GitCommit',
  PullRequestEvent: 'GitPullRequest',
  IssuesEvent: 'CircleDot',
  WatchEvent: 'Star',
  CreateEvent: 'Plus',
  ForkEvent: 'GitFork',
  DeleteEvent: 'Trash2',
  PullRequestReviewEvent: 'GitPullRequest',
};
